<template>
    <div>
        <div :id="id" class="modal">
            <div class="modal-content">
                <h4>{{header}}</h4>
                <p>{{content}}</p>
            </div>
            <div class="modal-footer">
                <a @click="action" v-for="(action, name) in actions" :key="name" class="modal-close waves-effect waves-green btn-flat">{{name}}</a>
            </div>
        </div>
    </div>
</template>
<style scoped>
    a {
        cursor: pointer;
    }
</style>

<script>
    export default {
        name: 'modal',
        props: {
            actions: Object,
            header: String,
            content: String,
        },
        data() {
            return {
                instance: null,
                id: Math.random().toString(36).substr(2, 9),
            }
        },
        mounted() {
            if (this.$el.querySelector(".modal")) {
                this.instance = M.Modal.init(this.$el.querySelector(".modal"), {
                    dismissible: false
                });
                this.instance.open()
            }
        },
    }
</script>


// WEBPACK FOOTER //
// src/components/Modal.vue